import { createApiSlice } from "@common";
import { CRUD_BUDGET_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addBudgetStatus",
    method: "post",
    url: CRUD_BUDGET_STATUS,
    stateKey: "message",
  },
  {
    name: "getBudgetStatus",
    method: "get",
    url: CRUD_BUDGET_STATUS,
    stateKey: "data",
  },
  {
    name: "updateBudgetStatus",
    method: "put",
    url: CRUD_BUDGET_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteBudgetStatus",
    method: "delete",
    url: CRUD_BUDGET_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"budgetStatus",
 apiConfig, 
 customReducers);
const budgetStatusSlice = slice;

export default budgetStatusSlice.reducer;

export const {
  addBudgetStatus,
  getBudgetStatus,
  updateBudgetStatus,
  deleteBudgetStatus,
} = thunks;

export const { rowSelect } = actions;
